import React from 'react';

type IconProps = {
    color?: string;
    width?: number;
    height?: number;
};

const IconLoadingSpinner: React.FC<IconProps> = ({ color, width = 50, height = 50 }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.0003 35.5C10.75 35.5 9.68753 35.9375 8.81245 36.8125C7.9377 37.6882 7.5 38.7504 7.5 40.0007C7.5 41.2511 7.93737 42.3133 8.81245 43.1891C9.68786 44.064 10.7503 44.5015 12.0003 44.5015C13.2295 44.5015 14.2866 44.064 15.1722 43.1891C16.0575 42.3144 16.5001 41.2511 16.5001 40.0007C16.5001 38.7504 16.0576 37.689 15.1722 36.8125C14.2865 35.9382 13.2295 35.5 12.0003 35.5Z"
                fill={color}
            />
            <path
                d="M11 26.0004C11 24.6254 10.5106 23.4487 9.53132 22.4686C8.55215 21.4895 7.37487 21 5.99992 21C4.62487 21 3.44781 21.4896 2.46853 22.4686C1.48947 23.4479 1 24.625 1 26.0004C1 27.3751 1.48936 28.5516 2.46853 29.5311C3.44781 30.5106 4.62487 31.0002 5.99992 31.0002C7.37487 31.0002 8.55215 30.5106 9.53132 29.5311C10.5106 28.5523 11 27.3751 11 26.0004Z"
                fill={color}
            />
            <path
                d="M40.0002 14.5005C40.6872 14.5005 41.2767 14.2553 41.7656 13.7659C42.2552 13.2761 42.5005 12.6874 42.5005 12C42.5005 11.3123 42.2552 10.724 41.7656 10.2345C41.2763 9.74474 40.6872 9.5 40.0002 9.5C39.3125 9.5 38.7237 9.74517 38.2341 10.2345C37.7448 10.7241 37.5 11.3123 37.5 12C37.5 12.6877 37.7448 13.2761 38.2341 13.7659C38.7237 14.2557 39.3125 14.5005 40.0002 14.5005Z"
                fill={color}
            />
            <path
                d="M12.0001 6.5C10.4791 6.5 9.18226 7.03654 8.10929 8.10929C7.03621 9.18204 6.5 10.4789 6.5 11.9997C6.5 13.521 7.03621 14.8173 8.10929 15.8905C9.18258 16.9636 10.4794 17.5 12.0001 17.5C13.5209 17.5 14.8178 16.9633 15.8905 15.8905C16.9633 14.8173 17.4998 13.5206 17.4998 11.9997C17.4998 10.4789 16.9633 9.18204 15.8905 8.10929C14.8178 7.03654 13.5209 6.5 12.0001 6.5Z"
                fill={color}
            />
            <path
                d="M48.1239 23.8747C47.5408 23.2914 46.8325 23 45.9994 23C45.1656 23 44.4574 23.2914 43.8742 23.8747C43.2914 24.4581 43 25.1666 43 26.0004C43 26.8334 43.2914 27.5428 43.8742 28.1249C44.4577 28.7085 45.1656 28.9999 45.9994 28.9999C46.8325 28.9999 47.5412 28.7085 48.1239 28.1249C48.7075 27.5422 48.9986 26.8334 48.9986 26.0004C48.9986 25.1671 48.708 24.4585 48.1239 23.8747Z"
                fill={color}
            />
            <path
                d="M40.0003 36.5C39.0414 36.5 38.2185 36.8435 37.5308 37.5312C36.8439 38.2181 36.5 39.0414 36.5 40.0003C36.5 40.9585 36.8439 41.7818 37.5308 42.4696C38.2185 43.1572 39.0415 43.5003 40.0003 43.5003C40.9585 43.5003 41.7813 43.1565 42.469 42.4696C43.1567 41.7819 43.5003 40.9589 43.5003 40.0003C43.5003 39.0414 43.1567 38.219 42.469 37.5312C41.7814 36.8434 40.9585 36.5 40.0003 36.5Z"
                fill={color}
            />
            <path
                d="M26.0004 41.998C24.8962 41.998 23.9534 42.3895 23.1717 43.1708C22.3907 43.9522 22 44.8945 22 45.9988C22 47.103 22.3903 48.0454 23.1717 48.8267C23.9534 49.6081 24.8958 49.9992 26.0004 49.9992C27.1047 49.9992 28.0471 49.6081 28.8284 48.8267C29.6098 48.0454 30.0005 47.103 30.0005 45.9988C30.0005 44.8945 29.6098 43.9522 28.8284 43.1708C28.0471 42.3895 27.1047 41.998 26.0004 41.998Z"
                fill={color}
            />
            <path
                d="M26.0002 0C24.3338 0 22.9165 0.583056 21.7497 1.74972C20.5833 2.91649 20 4.33346 20 6C20 7.66664 20.5831 9.08296 21.7497 10.2498C22.9165 11.4163 24.3335 11.9997 26.0002 11.9997C27.6674 11.9997 29.0837 11.4166 30.2501 10.2498C31.4164 9.08351 31.9997 7.66664 31.9997 6C31.9997 4.33357 31.4164 2.91692 30.2501 1.74972C29.0837 0.583385 27.6674 0 26.0002 0Z"
                fill={color}
            />
        </svg>
    );
};

export default IconLoadingSpinner;
